// extracted by mini-css-extract-plugin
module.exports = {"recentTransactionWrapper":"_2oSy-","cardWrapper":"_2vHoP"};